import React, { useEffect, useRef, useState } from "react";
import "./Refiller.css";
import { Cookies } from "react-cookie";
import axios from "axios";
import { ErrorAlert, SuccessAlert } from "../middleware/AlertMsg";
import { FaTrash } from "react-icons/fa";
import Loading from "../Loading";
import { useNavigate } from "react-router";
import RefillSheet from "./RefillSheet";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,TablePagination
} from '@mui/material';
import {HeaderTableCell,StyledTableRow,StyledTableCell} from '../Partials/TableStyle'
const Refiller_Refilling_Request = () => {
  const cookies = new Cookies();
  const token = cookies.get("JWTcookie");
  const [companies, setCompanies] = useState([]);
  const [showTable, setshowTable] = useState(false);
  const [isLoading, setLoading] = useState(false)
  const [machine, setMachine] = useState();
  const [updatedSlots, setUpdatedSlots] = useState([]);
  const [returnItems, setReturnItems] = useState([]);
  const navigate = useNavigate();
  const [productList, setProductList] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [isSearchVisible, setSearchVisible] = useState(false);
  const [ID, setID] = useState();
  const [selectedSuggestionIndex, setSelectedSuggestionIndex] = useState(-1);
  const [searchInput, setSearchInput] = useState("");
  // const baseUrl = 'https://busy-erin-raven-vest.cyclic.app';
 // const baseUrl = "https://officejeeves.com";
  const baseUrl =  process.env.REACT_APP_BASE_URL;
  const inputRef = useRef(null);
  const suggestionsContainerRef = useRef(null);
  const [isVisibleArray, setIsVisibleArray] = useState([]);
  const [openSuggestionIndex, setOpenSuggestionIndex] = useState(-1);
  const [sales, setSales] = useState({
    cash: 0,
    totalSalesCount: "",
    totalSalesValue: ""
  })

  const fetchProductList = async () => {
    try {
      const res = await axios.get(`${baseUrl}/api/Product/Datalist`, {
        headers: { Authorization: "Bearer " + token },
      });
      setProductList(res.data.data); // Assuming the API response is an array of products
      setFilteredProducts(res.data.data);
    } catch (error) {
      // console.log(error);
      ErrorAlert({
        title: "Fail",
        message: error.message,
      });
    }
  };
  const handleSearch = (e, id, index) => {
    setSearchVisible(true)
    setID(id);
    const value = e.target.value;
    const updatedVisibleArray = isVisibleArray.map((visible, i) =>
      i === index ? true : visible
    );
    setIsVisibleArray(updatedVisibleArray);
    const filtered = productList.filter(product =>
      product.productname.toLowerCase().includes(value.toLowerCase())
    );
    const newupdatedSlots = updatedSlots.map((item, i) => {
      if (id === item._id) {
        return {
          ...item,
          productname: value,
        }
      }
      else {
        return item
      }
    })
    // setUpdatedSlots((prevState) => ({ ...prevState, machineSlot: newupdatedSlots }));
    setUpdatedSlots(newupdatedSlots);
    setFilteredProducts(filtered);
  };


  const getCompanies = async () => {
    try {
      const res = await axios.get(`${baseUrl}/api/getallmachines`, {
        headers: { Authorization: "Bearer " + token },
      });
      const data = res.data.data;
      setCompanies(data);
    } catch (error) {
      // console.log(error);
      ErrorAlert({
        title: "Fail",
        message: "Please refresh the page",
      });
    }
  };

  const getMachineDetails = async (id) => {
    setLoading(true);
    setshowTable(true);
    try {
      const res = await axios.get(
        `${baseUrl}/api/getallmachineslots?machineid=${id}`,
        { headers: { Authorization: "Bearer " + token } }
      );
      const data = res.data.data;
      // console.log('data: ', data.machineSlot.sort((a, b) => a.slot.localeCompare(b.slot)));
      return data;
    }
    catch (error) {
      console.log(error);
      setLoading(false);
      ErrorAlert({
        title: "Fail",
        message: "Please refresh the page",
      });
    }
  };

  const handleMachineId = (e) => {
    const newMachineId = e.target.value;
    setReturnItems([]);
    setUpdatedSlots([]);
    getMachineDetails(newMachineId).then((res) => {
      if (res !== "") {
        setMachine(res);
        setshowTable(true);
      } else {
        setMachine();
        setReturnItems([])
        setshowTable(false);
      }
      setLoading(false);
    });
  };

  useEffect(() => {
    getCompanies();
  }, []);

  const handleRefillQty = (id, e) => {
    const value = e.target.value;
    const newmachine = machine.machineSlot.map((input) => {
      if (input._id === id) {
        const refillValue =
          value <= input.maxquantity - input.currentStock && value >= 0
            ? value
            : null;
        if (value > input.maxquantity - input.currentStock || value < 0) {
          e.target.value = refillValue;
          alert("Refill Quantity not greater than Slot capacity or Value should not be Negative");
        }

        return {
          ...input,
          refillQuantity: refillValue,
        };
      }
      return input;
    });
    setMachine((prevState) => ({ ...prevState, machineSlot: newmachine }));
  };

  const handleCurrentStock = (id, e) => {
    const value = e.target.value; // 5
    const newmachine = machine.machineSlot.map((item) => {
      if (item._id === id) {
        const CurrentStockValue = (value <= (item.maxquantity && item.closingStock)) && value >= 0 ? value : null;
        if (value > (item.maxquantity && item.closingStock) || value < 0) {
          alert("Current Stock is not greater than Closing Stock");
          e.target.value = CurrentStockValue
        }
        return {
          ...item,
          currentStock: CurrentStockValue,
          // saleQuantity: value <= item.maxquantity && value !== "" && CurrentStockValue !== 0 ? item.closingStock - Number(value) : 0,
          saleQuantity: Number(value) <= (item.maxquantity && item.closingStock) && Number(value) >= 0 && value !== "" ? item.closingStock - Number(value) : null,
        };
      }
      return item;
    });
    setMachine((prevState) => ({ ...prevState, machineSlot: newmachine }));
  };

  const handleDelete = (id) => {
    const shouldDelete = window.confirm("Are you sure to delete this item ?");
    // console.log('shouldDelete: ', shouldDelete);
    if (!shouldDelete) {
      return;
    }
    fetchProductList(); // call this function when refiller click to delete Item
    const removedItem = machine?.machineSlot.find((item) => item._id === id);
    if (removedItem) {
      if (removedItem.currentStock === null || removedItem.currentStock === "") {
        return alert("Please First fill current Stock Of Item")
      }
      // Update the returnItems state by adding the removed item
      const arr = [...returnItems, { ...removedItem, refillQuantity: 0 }];
      setReturnItems(arr);
      // setUpdatedSlots({ ...machine, machineSlot: arr });
      setUpdatedSlots(prev => [...prev, { ...removedItem, productname: "" }]);
      // Initialize isVisibleArray with false values
      setIsVisibleArray(new Array(arr.length).fill(false));
    }
    const newData = machine.machineSlot.filter((item, i) => id !== item._id);
    setMachine({ ...machine, machineSlot: newData });
  };

  const handleProductUpdateSlot = (product) => {
    // console.log('product: ', product); // new product which we want to update
    // console.log('ID: ', ID); // new product which we want to update
    setSearchVisible(false);
    const newupdatedSlots = updatedSlots.map((item, i) => {
      if (ID === item._id) {
        return {
          ...item,
          closingStock: 0,
          currentStock: 0,
          saleQuantity: 0,
          productname: product.productname,
          productid: product._id
        }
      }
      else {
        return item
      }
    })
    // setUpdatedSlots((prevState) => ({ ...prevState, machineSlot: newupdatedSlots }));
    setUpdatedSlots(newupdatedSlots);
    setIsVisibleArray(new Array(newupdatedSlots.length).fill(false));
    // setSelectedSuggestionIndex(-1);
  }

  const handleUpdatedProductRefillQty = (id, e) => {
    const newmachine = updatedSlots.map((input) => {
      if (input._id === id) {
        const refillValue = e.target.value <= input.maxquantity ? e.target.value : null;
        if (e.target.value > input.maxquantity) {
          alert("Refill Quantity not greater than Slot capacity");
          e.target.value = refillValue
        }
        return {
          ...input,
          refillQuantity: refillValue,
        };
      }
      return input;
    });
    setUpdatedSlots(newmachine);
  };

  const handleSubmit = async () => {
    const payload = { ...machine, machineSlot: [...machine.machineSlot, ...updatedSlots], returnItems, sales }

    const checkEmptyValueUpdatedSlots = updatedSlots.find((item) =>
      item.productname === ""
      || item.refillQuantity === null
      || item.refillQuantity === ""
    );

    if (checkEmptyValueUpdatedSlots) {
      return alert("Please Enter Updated Slots values")
    }

    if (sales.cash === "" || sales.totalSalesCount === "" || sales.totalSalesValue === "") {
      return alert("Please Enter Sales Value")
    }
    try {
      setLoading(true)
      const res = await axios.post(
        `${baseUrl}/api/refill/request`,
        payload,
        { headers: { Authorization: "Bearer " + token } }
      );
      const data = res.data;
      // console.log('data: ', data);
      if (data.success) {
        setLoading(false)
        SuccessAlert({
          title: "Success",
          message: "Slots update Request send successfully",
        });
        navigate("/")
      } else {
        ErrorAlert({
          title: "Fail",
          message: "Request not send successfully,Please try again",
        });
      }
    } catch (error) {
      // console.log(error);
      ErrorAlert({
        title: "Fail",
        message: "Request not send successfully,Please try again",
      });
    }
  };

  const handleSuggestionNavigation = (index) => {
    setSelectedSuggestionIndex(index);

    if (suggestionsContainerRef.current) {
      const suggestionElement =
        suggestionsContainerRef.current.children[index];
      if (suggestionElement) {
        suggestionElement.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "nearest",
        });
      }
    }
  };

  const handleKeyDown = (e, rowIndex) => {
    if (e.key === "ArrowUp") {
      e.preventDefault();
      const newIndex =
        selectedSuggestionIndex > 0
          ? selectedSuggestionIndex - 1
          : selectedSuggestionIndex;
      handleSuggestionNavigation(newIndex);
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      const newIndex =
        selectedSuggestionIndex < filteredProducts.length - 1
          ? selectedSuggestionIndex + 1
          : selectedSuggestionIndex;
      handleSuggestionNavigation(newIndex);
    } else if (e.key === "Enter") {
      e.preventDefault();
      handleProductUpdateSlot(filteredProducts[selectedSuggestionIndex]);
    }
  };

  useEffect(() => {
    if (selectedSuggestionIndex !== -1) {
      setSearchInput(filteredProducts[selectedSuggestionIndex]?.productname);
    }
  }, [selectedSuggestionIndex, filteredProducts]);

  //  console.log('machine: ', machine);
  // console.log("updatedSlots", updatedSlots) 
  // console.log('returnItems: ', returnItems);
  // console.log('filteredProducts: ', filteredProducts);

  const handleInputFocus = (productId) => {
    setOpenSuggestionIndex(productId);
  };

  return (
    <>

      <div className="table_container-div">
        <button className="refillerbackbtn"
          onClick={() => {
            navigate(-1);
          }}
        >
          Back
        </button>
        <div className="selectMachine">
          <label> Machine ID & Company ID</label>
          <select onChange={(e) => handleMachineId(e)} >
            <option value="">Select Machine</option>
            {companies.length > 0 &&
              companies?.map((item, i) => (
                <option key={item._id} value={item._id}>
                  {item.machinename}
                </option>
              ))}
          </select>
        </div>


        {showTable && <div>
          {!isLoading ?
            <>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <StyledTableRow>
                      <HeaderTableCell align='center'>Machine Name</HeaderTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    <StyledTableRow>
                      <StyledTableCell align='center'>{machine?.machineName}</StyledTableCell>
                    </StyledTableRow>
                  </TableBody>
                </Table>
                <Table>
                  <TableHead>
                    <StyledTableRow>
                      <HeaderTableCell>Slot Name</HeaderTableCell>
                      <HeaderTableCell>Product</HeaderTableCell>
                      <HeaderTableCell>Closing Stock</HeaderTableCell>
                      <HeaderTableCell>Current Stock</HeaderTableCell>
                      <HeaderTableCell>Refill Qty</HeaderTableCell>
                      <HeaderTableCell>Sale Qty</HeaderTableCell>
                      <HeaderTableCell>Action</HeaderTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {machine?.machineSlot.sort((a, b) => a.slot.localeCompare(b.slot)).map((item, i) => (
                      <StyledTableRow key={item._id} sx={{backgroundColor: i % 2 === 0 ? '#f5f5f5' : 'white',}}>
                        <StyledTableCell align="center">{item.slot}</StyledTableCell>
                        <StyledTableCell>{item.productname}</StyledTableCell>
                        <StyledTableCell align="right">{item.closingStock}</StyledTableCell>
                        <StyledTableCell className="tbody_td">
                          <input
                            className="td_input"
                            type="number"
                            // value={item.currentStock}
                            min="0"
                            placeholder={item.currentStock}
                            onChange={(e) => handleCurrentStock(item._id, e)}
                            required
                          />
                        </StyledTableCell>
                        <StyledTableCell className="tbody_td">
                          <input
                            className="td_input"
                            type="number"
                            // value={item.refillQuantity}
                            min="0"
                            placeholder={item.refillQuantity}
                            onChange={(e) => handleRefillQty(item._id, e)}
                          />
                        </StyledTableCell>
                        <StyledTableCell align="right">{item.saleQuantity}</StyledTableCell>
                        <StyledTableCell>
                          <div className="actionsBtn">
                            <FaTrash onClick={() => handleDelete(item._id)} />
                          </div>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
             </TableContainer>

              {updatedSlots.length > 0 && (
                <>
                  <div style={{
                    width: "90%", display: 'flex', margin: "auto", justifyContent: 'flex-start', backgroundColor: "black", color: "white", padding: "7px", marginTop: "30px",
                  }}>
                    <p>Update Slots with new Product :</p>
                  </div>
                  <Table>
                    <TableHead>
                      <StyledTableRow>
                        <HeaderTableCell>Slot Name</HeaderTableCell>
                        <HeaderTableCell>Product</HeaderTableCell>
                        <HeaderTableCell>Refill Qty</HeaderTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {updatedSlots?.map((item, index) =>
                        <StyledTableRow key={item._id} sx={{backgroundColor: index % 2 === 0 ? '#f5f5f5' : 'white',}}>
                          <StyledTableCell>{item.slot}</StyledTableCell>
                          <StyledTableCell>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                position: "relative"
                              }}
                            >
                              <input
                                style={{ padding: '7px', frontWeight: 'bold', fontSize: '16px' }}
                                ref={inputRef}
                                type="text"
                                placeholder={item.productname}
                                value={item.productname}
                                onClick={() => setSearchVisible(!isSearchVisible)}
                                onFocus={() => handleInputFocus(index)}
                                onChange={(e) => handleSearch(e, item._id, index)}
                                onKeyDown={handleKeyDown}
                              />
                              {openSuggestionIndex === index && isVisibleArray[index] && isSearchVisible && (
                                <div
                                  ref={suggestionsContainerRef}
                                  style={{
                                    minWidth: "300px",
                                    margin: "auto",
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                    backgroundColor: "white",
                                    display: "flex",
                                    flexDirection: "column",
                                    padding: "3px 3px",
                                    boxShadow: "rgba(0, 0, 0, 0.4) 0px 30px 90px",
                                    position: "absolute",
                                    top: "100%",
                                    // right: "1%",
                                    zIndex: "999999"
                                  }}
                                >
                                  {filteredProducts.map((product, index) => (
                                    <div
                                      key={product._id}
                                      onClick={() => handleProductUpdateSlot(product)}
                                      style={{
                                        cursor: "pointer",
                                        padding: "3px 10px 0px",
                                        boxShadow: "rgba(0, 0, 0, 0.45) 0px 25px 20px -20px",
                                        borderBottom: "1px solid gray",
                                        backgroundColor:
                                          index === selectedSuggestionIndex ? "lightblue" : "white"
                                      }}
                                    >
                                      {product.productname} {product.sellingprice}Rs
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          </StyledTableCell>
                          <StyledTableCell className="tbody_td">
                            <input
                              className="td_input"
                              type="number"
                              min="0"
                              // value={item.refillQuantity}
                              // placeholder={item.refillQuantity}
                              onChange={(e) => handleUpdatedProductRefillQty(item._id, e)}
                            />
                          </StyledTableCell>
                        </StyledTableRow>
                      )}
                    </TableBody>
                  </Table>
                  </>
              )}
              <div className="cashContainer">
                <label>Cash:</label>
                <input
                  placeholder="Enter Cash value"
                  type="number" min={0}
                  value={sales.cash}
                  onChange={(e) => setSales({ ...sales, cash: e.target.value })} />
                <label>Total Sales Count:</label>
                <input
                  placeholder="Enter Sales count"
                  type="number" min={0}
                  value={sales.totalSalesCount}
                  onChange={(e) => setSales({ ...sales, totalSalesCount: e.target.value })} />
                <label>Total Sales Value:</label>
                <input
                  placeholder="Enter Sales value"
                  type="number" min={0}
                  value={sales.totalSalesValue}
                  onChange={(e) => setSales({ ...sales, totalSalesValue: e.target.value })} />
              </div>
              <div className="input-lable-v-div">
                <button className="submit-btn" onClick={handleSubmit}>
                  Submit
                </button>
              </div>
            </>
            :
            <Loading />
          }
        </div>
        }
      </div>

     
    {
    !showTable && <div className="table_container-div">
      <RefillSheet/>
      </div> }


</>
   
  );
};

export default Refiller_Refilling_Request;
